import {Component, OnInit, inject} from '@angular/core';
import {HupSubscriptionsService} from '../../data/services/hup-subscriptions.service';
import {TranslationService} from '../../core/services/translation.service';
import {HupSubscription} from '../../data/models/subscription.model';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';
import {ConfigService} from '../../core/services/config.service';

@Component({
  selector: 'app-revocation',
  templateUrl: './revocation.component.html',
  styleUrls: ['./revocation.component.scss']
})
export class RevocationComponent implements OnInit {
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private navigationService = inject(NavigationService);
  translationService = inject(TranslationService);

  isLoadingSub = false;
  subs: HupSubscription[] = [];
  errorsArr: string[] = [];

  ngOnInit(): void {
    this.isLoadingSub = true;
    this.hupSubscriptionsService.getSubscriptions(true).subscribe({
      next: subs => {
        this.isLoadingSub = false;
        this.subs = subs;
        if (this.subs?.length === 1) {
          this.onNewRevocation(this.subs[0]);
        }
      },
      error: () => {
        this.isLoadingSub = false;
        this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
      }
    });
  }

  onNewRevocation(sub: HupSubscription): void {
    this.navigationService.navigateTo(NavigationCommand.REVOCATIONNEW, [sub.webId + '', sub.backendId + '']);
  }
}
